import { DefaultModal, ModalType } from '@frontend/components/kiosk';
import React from 'react';

const ID = 'lockout-modal';

export interface LockoutModalProps {
    show: boolean;
    remainingTime: number;
    onClose: () => void;
    title: React.ReactNode;
    description: React.ReactNode;
}

export const LockoutModal = (props: LockoutModalProps) => {
    return (
        <DefaultModal
            id={ID}
            handleClose={props.onClose}
            show={props.show}
            type={ModalType.PROMPT}
            className='bg-background-surface m-4 overflow-hidden rounded-xl p-6'>
            <div className='flex flex-col items-center justify-center gap-2'>
                <h2 className='text-always-black text-2xl font-semibold'>{props.title}</h2>
                <p className='text-always-black text-center text-base'>{props.description}</p>
                <div className='bg-status-danger text-background-surface flex size-16 items-center justify-center rounded-full'>
                    <span className='text-2xl font-bold'>{props.remainingTime}</span>
                </div>
            </div>
        </DefaultModal>
    );
};
